import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChartWaterfallAxis: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChartWaterfallAxis"><Path d="M4.5 19.5H21V21H3V3H4.5V19.5Z" fill="currentColor"/><Path d="M20.5 17H19V11H20.5V17Z" fill="currentColor"/><Path d="M12.5 15H11V9H12.5V15Z" fill="currentColor"/><Path d="M16.5 14H15V8H16.5V14Z" fill="currentColor"/><Path d="M8.5 11H7V5H8.5V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChartWaterfallAxis;
